import { render } from "./descriptionHotel.vue?vue&type=template&id=f197e902"
import script from "./descriptionHotel.vue?vue&type=script&lang=js"
export * from "./descriptionHotel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__